import { render, staticRenderFns } from "./errorPopUp.vue?vue&type=template&id=2408f79c&scoped=true"
import script from "./errorPopUp.vue?vue&type=script&lang=js"
export * from "./errorPopUp.vue?vue&type=script&lang=js"
import style0 from "./errorPopUp.vue?vue&type=style&index=0&id=2408f79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408f79c",
  null
  
)

export default component.exports